<template>
    <div class="min-h-screen flex flex-col bg-gray-950 text-gray-200">
      <!-- HERO SECTION COM TEMA ESCURO -->
      <section class="bg-gradient-to-b from-[#0a1a35] via-[#0c2550] to-[#0d3a7a] text-white min-h-screen md:min-h-0 py-0 md:py-16 relative overflow-hidden flex flex-col justify-center">
        <canvas ref="waveCanvas" class="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"></canvas>

  
        <div class="container mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-center gap-10 relative z-10 -mt-2 md:mt-0">
          <!-- BLOCO ESQUERDO -->
          <div class="md:w-1/2 text-center md:text-left flex flex-col items-center md:items-start">
            <div class=" p-4 rounded-2xl mb-6 inline-block">
              <img :src="Logo" alt="Logo" class="w-40 md:w-[280px] h-auto" />
            </div>
            <div class="md:flex space-x-4 mb-4">
              <img :src="LogoCircleWhite" alt="Saúde Pública Carioca" class="w-[320px] md:w-[600px] h-auto drop-shadow-lg" />
            </div>
            
            <h1 class="md:block text-sm md:text-3xl font-bold mb-4 leading-tight">
              <span class="text-gray-200">Place - CCDTI e Unidades Avançadas</span>
            </h1>
            

            

            
            <button @click="scrollToSection" class="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center group">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 group-hover:translate-y-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
              Ver Unidades
            </button>
          </div>
          
          <!-- BLOCO DIREITO (DECORATIVO) -->
          <div class="hidden md:block md:w-1/2 relative">
            <div class="absolute inset-0 flex items-center justify-center">

            </div>
          </div>
        </div>
  
        <!-- ANIMAÇÃO SETA -->
        <div class="absolute bottom-4 inset-x-0 z-10 animate-bounce flex justify-center md:hidden">
          <button @click="scrollToSection" class="bg-blue-500/20 backdrop-blur-sm p-3 rounded-full focus:outline-none hover:bg-blue-500/30 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </section>
  
      <!-- UNIDADES SECTION COM TEMA ESCURO -->
      <section id="unidades" class="py-4 md:py-4 bg-white relative bg-white">
        <!-- Elemento decorativo de transição -->
        <div class="absolute top-0 inset-x-0 h-16 bg-gradient-to-b from-gray-950 to-gray-900 hidden"></div>
        
        

  
        <div class="container mx-auto px-4 md:px-6">
          <div class="max-w-3xl mx-auto text-center mb-4">
            <div class="inline-flex items-center  justify-center p-1 px-3 mb-2 border border-blue-900 rounded-full bg-blue-600/30 text-gray-800 text-sm font-medium">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              Nossas Unidades
            </div>
          </div>
          
          <!-- Estado de carregamento -->
          <div v-if="isLoading" class="flex flex-col items-center justify-center py-16">
            <div class="w-16 h-16 border-4 border-gray-700 border-t-blue-500 rounded-full animate-spin mb-4"></div>
            <p class="text-gray-400 font-medium">Carregando unidades...</p>
          </div>
          
          <!-- Estado vazio -->
          <div v-else-if="unidades.length === 0" class="bg-gray-800 rounded-xl p-8 text-center max-w-2xl mx-auto border border-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-gray-600 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 class="text-xl font-semibold text-blue-300 mb-2">Nenhuma unidade encontrada</h3>
            <p class="text-gray-400 mb-4">Não foi possível carregar as unidades no momento. Por favor, tente novamente mais tarde.</p>
            <button @click="carregarUnidades" class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
              Tentar Novamente
            </button>
          </div>
          
          <!-- Lista de unidades -->
          <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            <div v-for="(unidade, index) in unidades" :key="index" 
                 class="bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-blue-900/20 transition-all duration-300 border border-gray-700 group">
              <!-- Cabeçalho do card -->
              <div class="bg-gradient-to-r from-blue-900 to-blue-700 h-3 w-full"></div>
              
              <div class="p-6">
                <!-- Ícone e nome -->
                <div class="flex items-center mb-4">
                  <div class="w-12 h-12 rounded-full bg-blue-900/30 flex items-center justify-center mr-4 text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <h3 class="text-xl font-semibold text-gray-200 group-hover:text-blue-400 transition-colors">
                    {{ unidade.nome }}
                  </h3>
                </div>
                
                <!-- Botões de acesso -->
                <div class="space-y-3 mt-6">
                  <a :href="unidade.place_url" target="_blank"
                     class="flex items-center justify-between bg-blue-700 text-white py-3 px-4 rounded-lg hover:bg-blue-600 transition-colors w-full group">
                    <span class="font-medium">Acessar Place</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- Footer com tema escuro -->
      <footer class="bg-[#0A1A35] text-gray-300 py-2 mt-auto">
        <div class="container mx-auto px-4 md:px-6">
          <!-- Logo centralizada -->
          <div class="flex justify-center mb-5">
            <img
              :src=LogoCircleWhite
              alt="Logo" class="w-[620px] md:w-[620px] h-auto opacity-90" />
          </div>
  
          <!-- Rodapé final -->
          <div class="pt-2 text-center text-sm text-gray-400">
            <p>&copy; {{ new Date().getFullYear() }} Desenvolvido por Tecnologia da Informação - CCDTI © Todos os direitos reservados</p>
          </div>
        </div>
      </footer>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import LogoCircleWhite from '@/assets/LogoCircleWhite.png';
  import Logo from '@/assets/Logo.png';
  
  const unidades = ref([]);
  const isLoading = ref(true);
  
  const carregarUnidades = async () => {
    isLoading.value = true;
    try {
      const response = await fetch('/api/v1/enterprises/unidades/links/');
      if (!response.ok) {
        throw new Error(`Erro HTTP ${response.status}`);
      }
      const data = await response.json();
      unidades.value = data
        .filter((unidade) => unidade.place_url)
        .sort((a, b) => a.nome.localeCompare(b.nome));
    } catch (err) {
      console.error('Erro ao buscar unidades:', err);
      unidades.value = [];
    } finally {
      isLoading.value = false;
    }
  };
  
  onMounted(async () => {
    // Inicializar canvas de ondas com cores para modo escuro
    initWaveCanvas();
    
    // Carregar unidades
    await carregarUnidades();
  });
  
  const scrollToSection = () => {
    const section = document.getElementById('unidades');
    if (section) section.scrollIntoView({ behavior: 'smooth' });
  };
  
  // Implementação da animação de ondas no canvas adaptada para modo escuro
  const initWaveCanvas = () => {
    const canvas = document.querySelector('canvas');
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    const waves = {
      y: canvas.height / 2,
      length: 0.01,
      amplitude: 100,
      frequency: 0.01
    };
    
    // Cores mais escuras e sutis para o modo noturno
    const strokeColor = {
      h: 210,
      s: '100%',
      l: '50%',
      a: 0.25
    };
    
    let increment = waves.frequency;
    
    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      ctx.beginPath();
      ctx.moveTo(0, canvas.height / 2);
      
      for (let i = 0; i < canvas.width; i++) {
        ctx.lineTo(
          i, 
          waves.y + Math.sin(i * waves.length + increment) * waves.amplitude * Math.sin(increment)
        );
      }
      
      ctx.strokeStyle = `hsla(${strokeColor.h}, ${strokeColor.s}, ${strokeColor.l}, ${strokeColor.a})`;
      ctx.stroke();
      increment += waves.frequency;
    }
    
    animate();
    
    window.addEventListener('resize', () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
  };
  </script>
  
  <style scoped>
  /* Animações e transições */
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0px); }
  }
  
  .animate-float {
    animation: float 6s ease-in-out infinite;
  }
  
  /* Estilos para scrollbar personalizada em modo escuro */
  ::-webkit-scrollbar {
    width: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: #1a1a2e;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #3a5998;
    border-radius: 5px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #4a69bd;
  }
  
  /* Efeito de brilho sutil para elementos no modo escuro */
  .glow-effect {
    box-shadow: 0 0 15px rgba(59, 130, 246, 0.3);
  }
  
  /* Melhorar contraste de texto no modo escuro */
  .text-shadow {
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  }
  </style>
